import { SplitContainer } from '@if/mui'
import { Card, CardContent, Skeleton, Stack } from '@mui/material'

// Mirrors a SummaryCard: an eyebrow heading over a few content rows.
const CardSkeleton = ({ rows = 4 }: { rows?: number }) => (
  <Card>
    <CardContent>
      <Stack spacing={2}>
        <Skeleton variant="text" width={180} height={20} />
        <Stack spacing={1.25}>
          {Array.from({ length: rows }).map((_, index) => (
            <Stack key={index} direction="row" justifyContent="space-between">
              <Skeleton variant="text" width={140} />
              <Skeleton variant="text" width={90} />
            </Stack>
          ))}
        </Stack>
      </Stack>
    </CardContent>
  </Card>
)

/**
 * Loading placeholder for the Funding Summary page, passed to `PageContainer`'s `loadingContent`.
 * Mirrors the loaded SplitContainer (main stack of SummaryCards + aside actions/help/notes) so the
 * layout doesn't shift when the resource resolves. The header/back link are rendered by
 * PageContainer from static props.
 */
const FundingSummarySkeleton = () => (
  <SplitContainer
    main={
      <Stack spacing={2.5}>
        <CardSkeleton rows={3} />
        <CardSkeleton rows={5} />
        <CardSkeleton rows={6} />
      </Stack>
    }
    aside={
      <Stack spacing={2.5}>
        <Skeleton variant="rounded" height={40} />
        <CardSkeleton rows={3} />
        <CardSkeleton rows={1} />
      </Stack>
    }
  />
)

export default FundingSummarySkeleton
